import TomSelect from 'tom-select';

export function tomSelectInit() {

	const propertyLookup = document.querySelector('.property-lookup select');

	if (propertyLookup) {
		const config = {
			maxItems: 1,
			openOnFocus: false,
			shouldLoad: function(query) {
				return ( query.length >= 3 );
			}
		};
		new TomSelect(propertyLookup, config);
	}

}
